import { JWTPayload } from 'jose';
import { UserInfo } from './UserInfo';
import { getUserRole } from './userUtils';
import { USER_GROUP_B2B, USER_GROUP_B2B_ADMIN, USER_GROUP_B2B_AGENT } from '@/constants';

const USER_GROUP_GUEST = 'guest';

const extractGroups = (payload: JWTPayload) => {
  return typeof payload['groups'] === 'string' ? [payload['groups']] : (payload['groups'] as Array<string>);
};

const extractRoles = (payload: JWTPayload) => {
  return typeof payload['roles'] === 'string' ? getUserRole(payload['roles']) : getUserRole(payload['roles'] as Array<string>);
};

const translateB2bRoles = (s: string) => {
  return s === USER_GROUP_B2B_AGENT || s === USER_GROUP_B2B_ADMIN ? USER_GROUP_B2B : s;
};

const translateB2bGroup = (s: Array<string>) => {
  return s.map((str) => translateB2bRoles(str));
};

function setUserInfoName(payload: JWTPayload, userInfo: UserInfo) {
  if (payload['name']) {
    userInfo.name = payload['name'] as string;
  } else if (payload['given_name'] || payload['family_name']) {
    userInfo.name = `${payload['given_name'] as string}`;
    if (payload['middle_name']) {
      userInfo.name += ` ${payload['middle_name'] as string}`;
    }
    userInfo.name += ` ${payload['family_name'] as string}`;
  }
}

function setPhoneNumber(payload: JWTPayload, userInfo: UserInfo) {
  if (payload['phone']) {
    userInfo.phone = payload['phone'] as string;
  } else if (payload['phone_number']) {
    userInfo.phone = payload['phone_number'] as string;
  }
}

export const createUserInfo = (payload: JWTPayload | null) => {
  const userInfo = {} as UserInfo;

  if (!payload) {
    return userInfo;
  }

  setUserInfoName(payload, userInfo);

  if (payload['email']) {
    userInfo.email = payload['email'] as string;
  }

  setPhoneNumber(payload, userInfo);

  if (payload['agency']) {
    userInfo.agency = payload['agency'] as string;
  }

  if (payload['agencyChain']) {
    userInfo.agencyChain = payload['agencyChain'] as string;
  }

  if (payload['agencyEmail']) {
    userInfo.agencyEmail = payload['agencyEmail'] as string;
  }

  if (payload['agencyPhone']) {
    userInfo.agencyPhone = payload['agencyPhone'] as string;
  }

  if (payload['agencyProvince']) {
    userInfo.agencyProvince = payload['agencyProvince'] as string;
  }

  // guest user is also determined by his groups but comes with a default value
  userInfo.isGuestUser = true;

  // user role has a default value extracted from groups
  if (payload['groups']) {
    userInfo.groups = translateB2bGroup(extractGroups(payload));
    userInfo.role = translateB2bRoles(getUserRole(userInfo.groups));
    userInfo.isGuestUser = userInfo.groups.includes(USER_GROUP_GUEST) || userInfo.groups.length == 0;
  }

  // if user role exists then it overrides the default role value from groups
  if (payload['roles']) {
    userInfo.role = translateB2bRoles(extractRoles(payload));
  }

  if (!Number.isNaN(payload['exp']) && payload['exp'] !== undefined) {
    userInfo.expiry = payload['exp'];
  }

  return userInfo;
};
